<template>
    <div>
    </div>
</template>
<script>
export default {
    name:"LogoutSSO"
}
</script>
